var App = App || {};

App.PrimaryNav = (function ($) {
    "use strict";

    var $nav,
        triggerSelector = '.primary-nav__level-1-item--has-children > .primary-nav__level-1-trigger > a',
        onTimer = new WeakMap(),
        offTimer = new WeakMap(),
        focusList = [],
        focusIndex = 0,
        currentMenu = null,
        openDelay = 250,
        closeDelay = 300;

    function init() {
        $nav = $('#primary-nav');

        // Escape closes the open menu and returns focus to trigger
        $(document).on('keydown', function (e) {
            if (e.key === 'Escape' && currentMenu) {
                e.preventDefault();
                var $trigger = getTriggerElement(currentMenu);
                closeMenu(currentMenu);
                $trigger.focus();
            }
        });

        // Keyboard navigation on trigger elements.
        $nav.on('keydown', triggerSelector, function (e) {
            var $this = $(this),
                $parent = $this.closest('li'),
                isNavigateClick = $this.data('clickBehavior') === 'navigate';

            // Enter or Space explicitly opens menu (keyboard users don't auto-open on focus).
            if (!isNavigateClick && (e.key === 'Enter' || e.key === ' ') && !$parent.hasClass('primary-nav__level-1-item--open')) {
                e.preventDefault();
                openMenu($parent);
                return;
            }

            if (e.key === 'ArrowLeft') {
                e.preventDefault();
                getTriggerElement($parent.prev('li')).focus();
            }

            if (e.key === 'ArrowRight') {
                e.preventDefault();
                getTriggerElement($parent.next('li')).focus();
            }

            if ($parent.hasClass('primary-nav__level-1-item--open') && e.key === 'ArrowDown') {
                e.preventDefault();
                if (focusList.length) { focusList[0].focus(); }
            }
        });

        $nav.on('click', triggerSelector, function (e) {
            var $trigger = $(this),
                $parent = $trigger.closest('.primary-nav__level-1-item--has-children'),
                isNavigateClick = $trigger.data('clickBehavior') === 'navigate';

            if (isNavigateClick) {
                return;
            }

            e.preventDefault();
            clearTimer(onTimer, $parent);
            clearTimer(offTimer, $parent);

            if ($parent.hasClass('primary-nav__level-1-item--open')) {
                closeMenu($parent);
                return;
            }

            openMenu($parent);
        });

        $nav.on('mouseenter focusin', '.primary-nav__level-1-item:not(.primary-nav__level-1-item--has-children)', function () {
            var $item = $(this);

            if (!currentMenu || currentMenu[0] === $item[0]) {
                return;
            }

            clearTimer(onTimer, currentMenu);
            clearTimer(offTimer, currentMenu);
            closeMenu(currentMenu);
        });

        // Keyboard navigation within the open menu
        $nav.on('keydown', '.primary-nav__menu', function (e) {
            var $parent = $nav.find('.primary-nav__level-1-item--open');

            if (e.key === 'ArrowDown') {
                e.preventDefault();
                if (focusIndex < focusList.length - 1) { focusIndex++; }
                focusList[focusIndex].focus();
            }

            if (e.key === 'ArrowUp') {
                e.preventDefault();
                if (focusIndex > 0) { focusIndex--; }
                focusList[focusIndex].focus();
            }

            if (e.key === 'ArrowLeft') {
                e.preventDefault();
                getTriggerElement($parent.prev('li')).focus();
            }

            if (e.key === 'ArrowRight') {
                e.preventDefault();
                getTriggerElement($parent.next('li')).focus();
            }
        });

        // MOUSE OPEN: only trigger open from the exact level-1 trigger area.
        $nav.find(triggerSelector)
            .on('mouseenter', function () {
                var $item = $(this).closest('.primary-nav__level-1-item--has-children');
                clearTimer(offTimer, $item);
                if (!$item.hasClass('primary-nav__level-1-item--open')) {
                    onTimer.set($item[0], setTimeout(function () {
                        if (isTriggerHovered($item)) {
                            openMenu($item);
                        }
                    }, openDelay));
                }
            })
            .on('mouseleave', function () {
                clearTimer(onTimer, $(this).closest('.primary-nav__level-1-item--has-children'));
            });

        // Keep currently-open menu alive while pointer is in its dropdown panel.
        $nav.find('.primary-nav__level-1-item--has-children > .primary-nav__menu')
            .on('mouseenter', function () {
                var $item = $(this).closest('.primary-nav__level-1-item--has-children');
                clearTimer(offTimer, $item);
            });

        // Keep current menu open when hovering within the menu container content.
        $nav.on('mouseenter', '.primary-nav__menu-container', function () {
            if (currentMenu) {
                clearTimer(offTimer, currentMenu);
            }
        });

        // MOUSE CLOSE: keep open while pointer is anywhere in level-1 nav or its descendants.
        $nav.find('.primary-nav__level-1')
            .on('mouseenter', function () {
                if (currentMenu) {
                    clearTimer(offTimer, currentMenu);
                }
            })
            .on('mouseleave', function (e) {
                if (!currentMenu || !currentMenu.hasClass('primary-nav__level-1-item--open')) {
                    return;
                }

                var relatedTarget = e.relatedTarget,
                    level1Element = this,
                    $item = currentMenu;

                if (relatedTarget && level1Element.contains(relatedTarget)) {
                    return;
                }

                clearTimer(onTimer, $item);
                offTimer.set($item[0], setTimeout(function () { closeMenu($item); }, closeDelay));
            });

        $nav.find('.primary-nav__level-1-item--has-children')
            // FOCUS IN: cancel any pending close but do NOT auto-open.
            // Keyboard users open with Enter; this just keeps the menu stable
            // when tabbing into an already-open dropdown.
            .on('focusin', function () {
                clearTimer(offTimer, $(this));
            })
            // FOCUS OUT: close if focus leaves the entire item/menu region
            .on('focusout', function (e) {
                var $item = $(this);
                if (e.relatedTarget && $item.has(e.relatedTarget).length) {
                    return;
                }
                clearTimer(onTimer, $item);
                if ($item.hasClass('primary-nav__level-1-item--open')) {
                    offTimer.set($item[0], setTimeout(function () { closeMenu($item); }, closeDelay));
                }
            });

        // Click outside nav closes any open menu
        $(document).on('click.primaryNav', function (e) {
            if (currentMenu && !$nav[0].contains(e.target)) {
                closeMenu(currentMenu);
            }
        });
    }

    function openMenu($item) {
        var $menu = $item.find('.primary-nav__menu'),
            menuElement = $menu.get(0);

        clearTimer(offTimer, $item);

        if (menuElement && menuElement._closeAnimationEndHandler) {
            menuElement.removeEventListener('animationend', menuElement._closeAnimationEndHandler);
            menuElement._closeAnimationEndHandler = null;
        }

        $menu.removeClass('fadeOutMenu');

        $item.siblings('.primary-nav__level-1-item--open').each(function () {
            closeMenu($(this));
        });

        focusList = [];
        focusIndex = 0;

        $.each($menu.find('a'), function () {
            focusList.push(this);
        });

        $item.addClass('primary-nav__level-1-item--open');
        getTriggerElement($item).attr('aria-expanded', 'true');

        $menu
            .addClass('animate__animated fadeInMenu')
            .addClass('d-flex');

        currentMenu = $item;

        if ($('#button-login').hasClass('header-primary__login--open')) {
            $('#button-login').removeClass('header-primary__login--open');
            $('#button-login').attr('aria-expanded', 'false');
        }

        // Show overlay/backdrop
        var $overlay = $('#primary-nav-overlay');
        if ($overlay.length === 0) {
            $overlay = $('<div id="primary-nav-overlay" class="primary-nav__overlay"></div>');
            $('body').append($overlay);
            $overlay.on('click', function () {
                if (currentMenu) { closeMenu(currentMenu); }
            });
        }
        $overlay.addClass('primary-nav__overlay--visible');
    }

    function closeMenu($item) {
        var $menu = $item.find('.primary-nav__menu'),
            menuElement = $menu.get(0);

        clearTimer(onTimer, $item);

        $item.removeClass('primary-nav__level-1-item--open');
        getTriggerElement($item).attr('aria-expanded', 'false');

        $menu
            .removeClass('fadeInMenu')
            .addClass('fadeOutMenu');

        if (menuElement && menuElement._closeAnimationEndHandler) {
            menuElement.removeEventListener('animationend', menuElement._closeAnimationEndHandler);
        }

        if (menuElement) {
            menuElement._closeAnimationEndHandler = function () {
                $menu
                    .removeClass('animate__animated fadeOutMenu')
                    .removeClass('d-flex');
                menuElement._closeAnimationEndHandler = null;
            };
            menuElement.addEventListener('animationend', menuElement._closeAnimationEndHandler, { once: true });
        }

        if ($item.siblings('.primary-nav__level-1-item--open').length === 0) {
            currentMenu = null;
            var $overlay = $('#primary-nav-overlay');
            if ($overlay.length) {
                $overlay.removeClass('primary-nav__overlay--visible');
                setTimeout(function () {
                    if (!$('.primary-nav__level-1-item--open').length) {
                        $overlay.remove();
                        $('body').removeClass('primary-nav__overlay-open').css('padding-right', '');
                        $('.site-header').css('padding-right', '');
                    }
                }, 220);
            }
        }
    }

    function getTriggerElement($item) {
        var $directLink = $item.children('a').first();

        if ($directLink.length) {
            return $directLink;
        }

        return $item.children('.primary-nav__level-1-trigger').find('a').first();
    }

    function isTriggerHovered($item) {
        return getTriggerElement($item).is(':hover');
    }

    function clearTimer(timerMap, $item) {
        var item = $item && $item.length ? $item[0] : null,
            timerId;
        if (!item) { return; }
        timerId = timerMap.get(item);
        if (timerId) {
            clearTimeout(timerId);
            timerMap.delete(item);
        }
    }

    return {
        init: init
    };
})(jQuery);

$(function () {
    App.PrimaryNav.init();
});

